import * as React from 'react';
import { StringModel } from '../../../models';
import Controller, { IAbstractDashboardControllerProps } from '../common/CommonDashboardController';
import View from './TranslatesView';

interface IStringTableViewControllerState {
    strings: StringModel[]
    limit: number
    skip: number
    dataCount: number
    searchText: string
    snackbarText: string
}

class StringTableViewController<P, S> extends Controller<P, S & IStringTableViewControllerState> {

    public static defaultProps: Partial<IAbstractDashboardControllerProps> = {
        title: 'Переводы'
    }

    constructor(props: any) {
        super(props);
        this.state = {
            loading: false,
            strings: [],
            skip: 0,
            limit: 25,
            dataCount: 0,
            searchText: '',
            snackbarText: ''
        } as any;
    }

    public async fia_componentWillMount() {
        this.setState({ loading: true });
        await this.loadStrings();
    }

    static get route() {
        return '/translate'
    }

    public onEdit(stringId: string) {
        this.props.history['push'](`/strings/edit`, { stringId });
    }

    public async onNewString() {
        this.props.history['push']('/strings/add')
    }

    public async loadStrings(s?: number, l?: number) {
        const { limit, skip } = this.state;
        const strings = await StringModel.loadStrings(s || s === 0 ? s : skip, l ? l : limit);
        const dataCount = await StringModel.getStringsCount();
        this.setState({ strings, dataCount, loading: false });
    }

    public async onSearchString(sText: string, l?: number, s?: number) {
        const { limit, skip } = this.state;
        this.setState({ searchText: sText });
        const strings = await StringModel.searchString(sText, l || l === 0 ? l : limit, s || s === 0 ? s : skip) as StringModel[];
        const dataCount = await StringModel.searchString(sText, l || l === 0 ? l : limit, s || s === 0 ? s : skip, true) as number;
        this.setState({ dataCount, strings, loading: false });
    }

    public async onChangePage(page: number) {
        const { limit, searchText } = this.state;
        const currentSkip = page * limit;
        this.setState({ skip: currentSkip, snackbarText: '', loading: true });
        if (searchText) {
            await this.onSearchString(searchText, limit, currentSkip);
        } else {
            await this.loadStrings(currentSkip);
        }
    }

    public async onChangeRowPerPage(rPP: number) {
        const { searchText } = this.state;
        this.setState({ limit: rPP, loading: true });
        if (this.state.searchText) {
            await this.onSearchString(searchText, rPP, this.state.skip);
        } else {
            await this.loadStrings(this.state.skip, rPP);
        }
    }

    public async onTextChanged(v: string, cName: string, index: number) {
        const { strings } = this.state;
        strings[index][cName] = v;
        this.setState({ strings, snackbarText: 'Изменения сохраняются...' });
        await strings[index].save();
        this.setState({ snackbarText: 'Изменения сохранены' });
    }

    public dashboard_render(): JSX.Element {
        const { loading, snackbarText, strings, limit, dataCount } = this.state
        return <View
            snackbarText={snackbarText}
            accessAvailable={this.accessAvailable}
            model={strings}
            loading={loading}
            onSearchString={(s: string) => this.onSearchString(s)}
            rowsPerPage={limit}
            dataCount={dataCount}
            onTextChange={(v: string, cName: string, index: number) => this.onTextChanged(v, cName, index)}
            onChangePage={(cP: number) => this.onChangePage(cP)}
            onChangeRowsPerPage={(rPP: number) => this.onChangeRowPerPage(rPP)}
        />
    }
}

export default StringTableViewController;



// WEBPACK FOOTER //
// ./src/app/dashboard/translates/TranslatesViewController.tsx